/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="whatIfDefinition" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}calculation" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class WhatIfModel extends ObjectType{

	whatIfDefinition = null;

	calculation = null;



	/**
	 * Gets the value of the whatIfDefinition property.
	 * @return {String} possible object is {@link String}
	 */
	getWhatIfDefinition() {
		return this.whatIfDefinition;
	}

	/**
	 * Sets the value of the whatIfDefinition property.
	 * @param {String} value allowed object is {@link String}
	 */
	setWhatIfDefinition(value) {
		var oldValue = this.whatIfDefinition;
		this.whatIfDefinition = value;
		this._setAndNotify(241, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the calculation property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculation property. <p> For example, to add a new item, do as follows: <pre> getCalculation().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Calculation}
	 */
	getCalculation() {
		if (!this.calculation) {
			this.calculation = [];
		}
		return this.calculation;
	}

	/**
	 * Gets the value of the <code>calculation</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Calculation</code> elements, or <code>null</code> if not set
	 */
	basicGetCalculation() {
		return this.calculation;
	}

	/**
	 * Creates a new instance of <code>WhatIfModel</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> WhatIfModel</code> object from.
	 * @return {WhatIfModel} an object of type <code>WhatIfModel</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createWhatIfModel();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addCalculationAt(position, item) {
		this._addAtAndNotify(this.getCalculation(), position, item, 61, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addCalculation(item) {
		this.addCalculationAt(this.getCalculation().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeCalculationAt(position) {
		this._removeAtAndNotify(this.getCalculation(), position, 61, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeCalculation(item) {
		var i = this.getCalculation().indexOf(item);
		if (i >= 0) {
			this.removeCalculationAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "WhatIfModel";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 241, "whatIfDefinition", null));
		var clazz;
		if (factory) {
			clazz = factory.createCalculation().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 61, "calculation", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 241:
			this.setWhatIfDefinition((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 61:
			this.calculation = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 241:
			return this.getWhatIfDefinition();
		case 61:
			return this.getCalculation();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 241:
			return this.getWhatIfDefinition();
		case 61:
			return this.basicGetCalculation();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 61:
			this.addCalculationAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 61:
			this.addCalculation((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 61:
			this.removeCalculationAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 61:
			this.removeCalculation((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/WhatIfModel.js